function openOffersHandler() {
    let offers = document.querySelectorAll(".sk-uigroup--offers a.tabs-opener");
    let offerTabOpen = document.querySelectorAll(".sk-uigroup--offers .sect-opener")
    if ( offers.length ) {
        offers.forEach(item => {
            item.addEventListener("click", (e) => openOffer(e, item), false);
        });
    }
    if ( offerTabOpen.length ) {
        offerTabOpen.forEach(item => {
            item.addEventListener("click", (e) => openOffer(e, item), false);
        });
    }
}
function openOffer(e, item) {
    e.preventDefault();
    toggleTabsGroup(item);
    item.classList.toggle("open");
}

function toggleTabsGroup(elem) {
    var link = elem;
    var tabGroup = link.closest(".sk-uigroup-item-content").querySelector(".sk-tabgroup");
    tabGroup.classList.toggle("sk-tabgroup--expanded");
}

export { openOffersHandler };